export const Images = () => {
  return (
    <section className="section" id="images">
      <h1 className="title"> Images </h1>
      <hr />
      <figure className="image is-128x128">
        <img src="https://media.licdn.com/dms/image/C560BAQHPEhawj1hjIg/company-logo_200_200/0/1630670195428?e=2147483647&v=beta&t=okitgnrzLVM2V9Uhrt8XslRihTIv6L2B7eH5AM7ATIE" />
      </figure>
    </section>
  );
};
